import { useEffect, useRef, useState } from 'react';
import { Pressable, Text, View } from 'react-native';

import { subscribeNetworkError, type NetworkErrorEvent } from '@/lib/net/net-status';

const AUTO_DISMISS_MS = 8000;

export function NetworkErrorToast() {
  const [event, setEvent] = useState<NetworkErrorEvent | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return subscribeNetworkError((next) => {
      setEvent(next);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => setEvent(null), AUTO_DISMISS_MS);
    });
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  if (!event) {
    return null;
  }

  return (
    <View className="absolute left-0 right-0 top-4 z-50 items-center px-4">
      <View className="w-full max-w-md flex-row items-start gap-3 rounded-xl border border-danger bg-danger-muted px-4 py-3 shadow-lg">
        <View className="flex-1">
          <Text className="text-sm font-semibold text-danger">{event.message}</Text>
          {event.detail ? <Text className="mt-0.5 text-xs text-danger">{event.detail}</Text> : null}
        </View>
        <Pressable onPress={() => setEvent(null)} className="rounded-md px-2 py-1">
          <Text className="text-sm font-medium text-danger">Dismiss</Text>
        </Pressable>
      </View>
    </View>
  );
}
